import React, { useEffect, useState } from "react";
import { Col, Row, Form, DatePicker, Select, message } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import MedicalService from "../../../Services/MedicalService";
import { useSelector } from "react-redux";

function AddVaccination(props) {
  const [form] = Form.useForm();
  const activePatient = JSON.parse(sessionStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const [vaccineValue, setVaccineValue] = useState();
  const [chronicCode, setChronicCode] = useState([]);
  const [vaccineDesc, setVaccineDesc] = useState();
  const { patientData } = useSelector((state) => state.auth);
  const patientName = `${activePatient?.salutation || ""}${
    activePatient?.firstName || ""
  } ${activePatient?.lastName || ""}`.trim();
  const [disable, setDisable] = useState(false);

  const handleCancel = () => {
    props.onClose();
  };
  const handlehealthChange = (value, desc) => {
    setVaccineValue(value);
    setVaccineDesc(desc.description);
  };

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const vaccines = [
    { description: "Influenza(Flu)", code: "Influenza(Flu)" },
    {
      description: "Tetanus, Diphtheria, Pertussis (Td, Tdap)",
      code: "Tetanus, Diphtheria, Pertussis(Td,Tdap)",
    },
    { description: "Zoster (Shingles)", code: "Zoster(Shingles)" },
    {
      description: "Pneumococcal (PCV13, PPSV23)",
      code: "Pneumococcal(PCV13,PPSV23)",
    },
    { description: "Varicella (Chickenpox)", code: "Varicella(Chickenpox)" },
    {
      description: "Human Papillomavirus (HPV)",
      code: "Human Papillomavirus(HPV)",
    },
    {
      description: "Measles, Mumps, Rubella (MMR)",
      code: "Measles, Mumps, Rubella (MMR)",
    },
    { description: "Meningococcal", code: "Meningococcal" },
    { description: "Hepatitis A", code: "Hepatitis A" },
    { description: "Hepatitis B", code: "Hepatitis B" },
    {
      description: "Haemophilus influenzae type b (Hib)",
      code: "Haemophilus influenzae type b (Hib)",
    },
  ];

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const onFinish = async (values) => {
    setDisable(true);
    if (!vaccineDesc || !values.givenDate) {
      message.error("Please fill all fields");
      setDisable(false);
      return;
    }
    let payload = {
      account_Id: patientData?.account_Id,
      clinic_Id: patientData?.clinic_Id,
      createdBy: patientCode,
      modifiedBy: patientCode,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      createdName: patientName,
      description: vaccineDesc,
      givenDate: dayjs(values.givenDate, "YYYY-MM-DD HH:mm:ss").format(
        "YYYY-MM-DD HH:mm:ss",
      ),
      patientId: props.selectedPatient.patientId,
      status: 1,
    };

    try {
      await MedicalService.AddImmunisationHistory(payload);
      setDisable(false);
      props.onClose();
    } catch (e) {
      console.error(e);
      setDisable(false);
    }
  };

  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        onFinish={onFinish}
      >
        <div className="border rounded-lg p-2">
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label={
                  <span>
                    Immunisation <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="pastInfo"
              >
                <Select
                  style={{ width: "100%" }}
                  onChange={handlehealthChange}
                  placeholder="Select"
                  value={vaccineValue}
                  options={vaccines.map((ele) => ({
                    value: ele.code,
                    description: ele.description,
                    label: ele.description,
                    key: ele.code,
                  }))}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label={
                  <span>
                    Date <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="givenDate"
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Select"
                  format="MM-DD-YYYY"
                  disabledDate={disabledFutureDate}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex items-center w-full justify-end my-5 gap-3">
                <button
                  onClick={handleCancel}
                  className="border-[#189FAA] border rounded-sm text-[#189FAA] text-sm px-6 py-1.5"
                >
                  Cancel
                </button>
                <button
                  disabled={disable}
                  className="bg-secondaryColor border-brand-secondaryColor border rounded px-5 py-1.5 text-brand-white text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Submit
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}

export default AddVaccination;
